import { Popover, Tab, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import { BsYoutube } from "react-icons/bs";
import { FaEnvelope, FaFacebookF, FaInstagram } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa6";
import { HiOutlineMenuAlt1 } from "react-icons/hi";
import { IoChevronDownOutline, IoChevronUpOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import MobileHeader from "./MobileHeader";

const navigation = {
  arena: [
    {
      name: "Victoris",
      link: "/vehicles/victoris",
      img: require("../../assets/thumbnails/victoris.webp"),
    },
    {
      name: "Alto K10",
      link: "/vehicles/alto-k10",
      img: require("../../assets/thumbnails/alto-k10.webp"),
    },
    {
      name: "Brezza",
      link: "/vehicles/brezza",
      img: require("../../assets/thumbnails/brezza.webp"),
    },
    {
      name: "Celerio",
      link: "/vehicles/celerio",
      img: require("../../assets/thumbnails/celerio.webp"),
    },
    {
      name: "Dzire",
      link: "/vehicles/dzire",
      img: require("../../assets/thumbnails/dzire.webp"),
    },
    {
      name: "EECO",
      link: "/vehicles/eeco",
      img: require("../../assets/thumbnails/eeco.webp"),
    },
    {
      name: "Ertiga",
      link: "/vehicles/ertiga",
      img: require("../../assets/thumbnails/ertiga.webp"),
    },
    {
      name: "S-Presso",
      link: "/vehicles/s-presso",
      img: require("../../assets/thumbnails/spresso.webp"),
    },
    {
      name: "Swift",
      link: "/vehicles/swift",
      img: require("../../assets/thumbnails/swift.webp"),
    },
    {
      name: "Wagon R",
      link: "/vehicles/wagonR",
      img: require("../../assets/thumbnails/wagonr.webp"),
    },
  ],
  nexa: [
    {
      name: "E-Vitara",
      link: "/vehicles/e-vitara",
      img: require("../../assets/nexa/e-vitara.webp"),
    },
    {
      name: "Invicto",
      link: "/vehicles/invicto",
      img: require("../../assets/nexa/invicto.webp"),
    },
    {
      name: "Fronx",
      link: "/vehicles/fronx",
      img: require("../../assets/nexa/fronx.png"),
    },
    {
      name: "Jimny",
      link: "/vehicles/jimny",
      img: require("../../assets/nexa/jimny.png"),
    },
    {
      name: "Baleno",
      link: "/vehicles/baleno",
      img: require("../../assets/nexa/baleno.png"),
    },
    // {
    //   name: "Ciaz",
    //   link: "/vehicles/ciaz",
    //   img: require("../../assets/nexa/ciaz.webp"),
    // },
    {
      name: "Ignis",
      link: "/vehicles/ignis",
      img: require("../../assets/nexa/ignis.webp"),
    },
    // {
    //   name: "S-Cross",
    //   link: "/vehicles/scross",
    //   img: require("../../assets/nexa/scross.webp"),
    // },
    {
      name: "XL6",
      link: "/vehicles/xl6",
      img: require("../../assets/nexa/xl6.webp"),
    },
    {
      name: "Grand Vitara",
      link: "/vehicles/grandvitara",
      img: require("../../assets/nexa/grandvitara.webp"),
    },
  ],
  commercial: [
    {
      name: "Super Carry",
      link: "/vehicles/super-carry",
      img: require("../../assets/goods/carry.webp"),
    },
    {
      name: "EECO Cargo",
      link: "/vehicles/eeco-cargo",
      img: require("../../assets/goods/cargo.webp"),
    },
  ],
  suzuki: [
    {
      name: "V-Storm SX",
      link: "/vehicles/v-storm",
      img: require("../../assets/v-storm/1.png"),
    },
    {
      name: "S-250/SF-250",
      link: "/vehicles/s-250",
      img: require("../../assets/s-250/1.png"),
    },
    {
      name: "Gixxer SF",
      link: "/vehicles/gixxer-sf",
      img: require("../../assets/sf/1.png"),
    },
    // {
    //   name: "Hayabusa",
    //   link: "/vehicles/hayabusa",
    //   img: require("../../assets/hayabusa/1.png"),
    // },
    {
      name: "Avenis",
      link: "/vehicles/avenis",
      img: require("../../assets/avenis/1.jpg"),
    },
    {
      name: "Access 125",
      link: "/vehicles/access-125",
      img: require("../../assets/access/1.png"),
    },
    {
      name: "Burgman Street",
      link: "/vehicles/burgman-street",
      img: require("../../assets/street/1.jpg"),
    },
    {
      name: "e-ACCESS",
      link: "/vehicles/e-access",
      img: "https://ik.imagekit.io/rahul116/bikes/e-access/white.webp?updatedAt=1777289929040",
    },
  ],
  pages: [
    { name: "Home", to: "/" },
    { name: "About Us", to: "/about" },
  ],
  servicepages: [
    {
      name: "Book A Service",
      to: "/book-a-service",
    },
    {
      name: "Finance",
      to: "/finance",
    },
    {
      name: "Insurance",
      to: "/insurance",
    },

    {
      name: "Driving School",
      to: "/driving-school",
    },

    // {
    //   name: "Driving School",
    //   to: "/driving-school-hyderabad",
    // },
  ],
  morepages: [
    {
      name: "Gallery",
      to: "/gallery",
    },
    {
      name: "Blogs",
      to: "/blog",
    },
  ],
  truevaluepages: [
    {
      name: "Buy Used Cars",
      to: "/used-cars-sale",
    },
    {
      name: "Sell A Car",
      to: "/sell-old-cars",
    },
  ],
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Header() {
  return (
    <>
      <TopHeader />
      <MainHeader />
      <MobileHeader />
    </>
  );
}

const TopHeader = () => {
  return (
    <div className="px-5 py-3 text-white bg-red-600 xl:px-0">
      <div className="items-center max-w-screen-xl mx-auto text-sm font-light sm:flex sm:justify-between">
        <div className="flex items-center space-x-2 md:text-sm">
          <p className="font-semibold ">
            Hyderabad's Most Reliable Maruti Dealer
          </p>
        </div>
        <div className="flex items-center space-x-3">
          <a
            href="mailto:srcg@gmail.com"
            className="flex items-center font-semibold "
          >
            <FaEnvelope className="mr-1" />
          </a>
          <a
            href="https://www.facebook.com/GemMarutiOfficial/"
            target={"_blank"}
            rel="noreferrer"
          >
            <FaFacebookF />
          </a>

          <span>
            <FaLinkedin />
          </span>
          <a
            href="https://www.instagram.com/gemmarutiofficial/"
            target={"_blank"}
            rel="noreferrer"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.youtube.com/@gemmarutisuzuki"
            className="hover:text-red-600"
            target={"_blank"}
            rel="noreferrer"
          >
            <BsYoutube />
          </a>
        </div>
      </div>
    </div>
  );
};

const MainHeader = () => {
  const [navbar, setNavbar] = useState(false);
  const [openChannels, setOpenChannels] = useState(false);
  const [openServices, setOpenServices] = useState(false);
  const [openMore, setOpenMore] = useState(false);
  const [openTruevalue, setOpenTruevalue] = useState(false);
  useEffect(() => {
    const fixedNavbar = () => {
      setNavbar(window.scrollY >= 100);
    };

    window.addEventListener("scroll", fixedNavbar);
    // run once to set initial state
    fixedNavbar();

    return () => {
      window.removeEventListener("scroll", fixedNavbar);
    };
  }, []);
  return (
    <div
      className={` ${
        navbar
          ? " fixed top-0 z-20 w-full   shadow-2xl drop-shadow-2xl bg-white"
          : "border-b"
      } hidden lg:block px-5 xl:px-0`}
    >
      <header className="relative">
        <nav aria-label="Top" className="max-w-screen-xl mx-auto ">
          <div className="border-gray-200">
            <div className="flex items-center">
              {/* Logo */}
              <div className="mr-auto flex lg:ml-0 ml-2 my-1.5">
                <Link to="/">
                  <img
                    className="w-auto h-16"
                    src={require("../../assets/logo.jpg")}
                    alt="logo"
                    loading="eager"
                  />
                </Link>
              </div>

              <button
                type="button"
                className="p-2 text-gray-900 rounded-md lg:hidden"
              >
                <span className="sr-only">Open menu</span>
                <HiOutlineMenuAlt1 className="w-6 h-6" aria-hidden="true" />
              </button>

              {/* Flyout menus */}
              <Popover.Group className="hidden ml-auto lg:block lg:self-stretch">
                <div className="flex h-full space-x-8">
                  {navigation.pages.map((page) => (
                    <Link
                      key={page.name}
                      to={page.to}
                      className="flex items-center text-sm font-medium text-black hover:text-red-600 "
                    >
                      {page.name}
                    </Link>
                  ))}

                  {/* OUR CHANNELS DROPDOWN - FIXED */}
                  <Popover
                    className="flex"
                    onMouseEnter={() => setOpenChannels(true)}
                    onMouseLeave={() => setOpenChannels(false)}
                    open={openChannels}
                  >
                    <div className="relative flex">
                      <Popover.Button
                        className={classNames(
                          openChannels
                            ? "border-[#051641] text-red-600"
                            : "border-transparent text-black ",
                          "relative z-10 flex items-center transition-colors ease-out duration-200 text-sm font-medium border-b-2 -mb-px pt-px outline-none hover:text-red-600",
                        )}
                      >
                        Our Channels
                        {openChannels ? (
                          <IoChevronUpOutline className="ml-1 h-4 w-4 text-[#051641] transition-transform duration-300" />
                        ) : (
                          <IoChevronDownOutline className="w-4 h-4 ml-1 text-black transition-transform duration-300" />
                        )}
                      </Popover.Button>
                    </div>

                    {/* Dropdown */}
                    <Transition
                      as={Fragment}
                      show={openChannels}
                      enter="transition ease-out duration-200"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="transition ease-in duration-150"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <Popover.Panel className="absolute inset-x-0 z-10 text-sm text-gray-500 bg-white shadow top-full">
                        <div className="relative pt-6 bg-white">
                          <div className="max-w-screen-xl px-8 mx-auto">
                            {/* TAB GROUP */}
                            <Tab.Group>
                              <div className="grid grid-cols-4">
                                {/* LEFT TABS */}
                                <div className="col-span-1">
                                  <Tab.List className="space-x-3">
                                    {[
                                      "Arena",
                                      "Nexa",
                                      "Commercial",
                                      "Suzuki",
                                    ].map((label, idx) => (
                                      <Tab
                                        key={idx}
                                        className={({ selected }) =>
                                          classNames(
                                            selected
                                              ? "bg-blue-600 text-white"
                                              : "bg-gray-200 text-black hover:bg-blue-400 hover:text-white",
                                            "mb-3 rounded-lg outline-none max-w-[260px] w-full ml-3 py-4 px-4",
                                          )
                                        }
                                      >
                                        {label}
                                      </Tab>
                                    ))}
                                  </Tab.List>
                                </div>

                                {/* RIGHT CONTENT */}
                                <div className="col-span-3 px-3">
                                  <Tab.Panels>
                                    {/* Arena */}
                                    <Tab.Panel>
                                      <div className="grid grid-cols-5 gap-4 py-6 gap-x-8">
                                        {navigation.arena.map((item, i) => (
                                          <div
                                            key={i}
                                            className="relative text-base group sm:text-sm"
                                          >
                                            <div className="overflow-hidden bg-gray-100 rounded-lg aspect-w-1 aspect-h-1 group-hover:opacity-75">
                                              <img
                                                src={item.img}
                                                alt={i}
                                                loading="lazy"
                                                className="object-center object-cover mx-auto h-[115px] rounded-lg group-hover:opacity-75"
                                              />
                                            </div>
                                            <a
                                              href={item.link}
                                              className="block mt-3 font-medium text-center text-gray-900"
                                            >
                                              <span
                                                className="absolute inset-0 z-10"
                                                aria-hidden="true"
                                              />
                                              {item.name}
                                            </a>
                                          </div>
                                        ))}
                                      </div>
                                    </Tab.Panel>

                                    {/* Nexa */}
                                    <Tab.Panel>
                                      <div className="grid grid-cols-4 gap-4 py-6 gap-x-8">
                                        {navigation.nexa.map((item, i) => (
                                          <div
                                            key={i}
                                            className="relative text-base group sm:text-sm"
                                          >
                                            <div className="overflow-hidden bg-gray-100 rounded-lg aspect-w-1 aspect-h-1 group-hover:opacity-75">
                                              <img
                                                src={item.img}
                                                loading="lazy"
                                                alt={i}
                                                className="object-cover object-center mx-auto rounded-lg"
                                              />
                                            </div>
                                            <a
                                              href={item.link}
                                              className="block mt-3 font-medium text-center text-gray-900"
                                            >
                                              <span
                                                className="absolute inset-0 z-10"
                                                aria-hidden="true"
                                              />
                                              {item.name}
                                            </a>
                                          </div>
                                        ))}
                                      </div>
                                    </Tab.Panel>
                                    {/* commercial*/}
                                    <Tab.Panel>
                                      <div className="grid grid-cols-4 gap-4 py-6 gap-x-8">
                                        {navigation.commercial.map(
                                          (item, i) => (
                                            <div
                                              key={i}
                                              className="relative text-base group sm:text-sm"
                                            >
                                              <div className="overflow-hidden bg-gray-100 rounded-lg aspect-w-1 aspect-h-1 group-hover:opacity-75">
                                                <img
                                                  src={item.img}
                                                  loading="lazy"
                                                  alt={i}
                                                  className="object-cover object-center mx-auto rounded-lg"
                                                />
                                              </div>
                                              <a
                                                href={item.link}
                                                className="block mt-3 font-medium text-center text-gray-900"
                                              >
                                                <span
                                                  className="absolute inset-0 z-10"
                                                  aria-hidden="true"
                                                />
                                                {item.name}
                                              </a>
                                            </div>
                                          ),
                                        )}
                                      </div>
                                    </Tab.Panel>
                                    {/* suzuki */}
                                    <Tab.Panel>
                                      <div className="grid grid-cols-4 gap-4 py-6 gap-x-8">
                                        {navigation.suzuki.map((item, i) => (
                                          <div
                                            key={i}
                                            className="relative text-base group sm:text-sm"
                                          >
                                            <div className="overflow-hidden bg-gray-100 rounded-lg aspect-w-1 aspect-h-1 group-hover:opacity-75">
                                              <img
                                                src={item.img}
                                                loading="lazy"
                                                alt={i}
                                                className="object-cover object-center mx-auto rounded-lg"
                                              />
                                            </div>
                                            <a
                                              href={item.link}
                                              className="block mt-3 font-medium text-center text-gray-900"
                                            >
                                              <span
                                                className="absolute inset-0 z-10"
                                                aria-hidden="true"
                                              />
                                              {item.name}
                                            </a>
                                          </div>
                                        ))}
                                      </div>
                                    </Tab.Panel>
                                  </Tab.Panels>
                                </div>
                              </div>
                            </Tab.Group>
                          </div>
                        </div>
                      </Popover.Panel>
                    </Transition>
                  </Popover>

                  {/* TrueValue - FIXED */}
                  <div
                    onMouseEnter={() => setOpenTruevalue(true)}
                    onMouseLeave={() => setOpenTruevalue(false)}
                    className="flex"
                  >
                    <Popover className="flex" open={openTruevalue}>
                      <Popover.Button
                        className={classNames(
                          openTruevalue
                            ? "border-[#051641] text-red-600"
                            : "border-transparent text-black hover:text-red-600",
                          "relative z-10 flex hover:text-red-600 items-center transition-colors ease-out duration-200 text-sm font-medium border-b-2 -mb-px pt-px outline-none",
                        )}
                      >
                        True Value
                        {openTruevalue ? (
                          <IoChevronUpOutline className="ml-1 h-4 w-4 text-[#051641] transition-transform duration-300" />
                        ) : (
                          <IoChevronDownOutline className="w-4 h-4 ml-1 text-black transition-transform duration-300" />
                        )}
                      </Popover.Button>

                      <Transition
                        as={Fragment}
                        show={openTruevalue}
                        enter="transition ease-out duration-200"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <Popover.Panel className="absolute top-full -ml-6 text-sm shadow rounded overflow-hidden w-full max-w-[130px] bg-white z-20">
                          {navigation.truevaluepages.map((item, index) => (
                            <Link to={item.to} key={index}>
                              <p className="relative p-3 bg-white hover:bg-gray-100 hover:text-red-600">
                                {item.name}
                              </p>
                            </Link>
                          ))}
                        </Popover.Panel>
                      </Transition>
                    </Popover>
                  </div>
                  {/* SERVICES DROPDOWN - FIXED */}
                  <div
                    onMouseEnter={() => setOpenServices(true)}
                    onMouseLeave={() => setOpenServices(false)}
                    className="flex"
                  >
                    <Popover className="flex" open={openServices}>
                      <Popover.Button
                        className={classNames(
                          openServices
                            ? "border-[#051641] text-red-600"
                            : "border-transparent text-black hover:text-red-600",
                          "relative z-10 flex hover:text-red-600 items-center transition-colors ease-out duration-200 text-sm font-medium border-b-2 -mb-px pt-px outline-none",
                        )}
                      >
                        Services
                        {openServices ? (
                          <IoChevronUpOutline className="ml-1 h-4 w-4 text-[#051641] transition-transform duration-300" />
                        ) : (
                          <IoChevronDownOutline className="w-4 h-4 ml-1 text-black transition-transform duration-300" />
                        )}
                      </Popover.Button>

                      <Transition
                        as={Fragment}
                        show={openServices}
                        enter="transition ease-out duration-200"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <Popover.Panel className="absolute top-full -ml-6 text-sm shadow rounded overflow-hidden w-full max-w-[130px] bg-white z-20">
                          {navigation.servicepages.map((item, index) => (
                            <Link to={item.to} key={index}>
                              <p className="relative p-3 bg-white hover:bg-gray-100 hover:text-red-600">
                                {item.name}
                              </p>
                            </Link>
                          ))}
                        </Popover.Panel>
                      </Transition>
                    </Popover>
                  </div>

                  <Link
                    to="/outlets"
                    className="flex items-center text-sm font-medium hover:text-red-600 "
                  >
                    Outlets
                  </Link>

                  {/* <Link
                    to="/careers"
                    className="flex items-center text-sm font-medium "
                  >
                    Careers
                  </Link> */}

                  <Link
                    to="/contact-us"
                    className="flex items-center text-sm font-medium hover:text-red-600"
                  >
                    Contact
                  </Link>
                  <div
                    onMouseEnter={() => setOpenMore(true)}
                    onMouseLeave={() => setOpenMore(false)}
                    className="flex"
                  >
                    <Popover className="flex" open={openMore}>
                      <Popover.Button
                        className={classNames(
                          openMore
                            ? "border-[#051641] text-red-600"
                            : "border-transparent text-black hover:text-red-600",
                          "relative z-10 flex hover:text-red-600 items-center transition-colors ease-out duration-200 text-sm font-medium border-b-2 -mb-px pt-px outline-none",
                        )}
                      >
                        More
                        {openMore ? (
                          <IoChevronUpOutline className="ml-1 h-4 w-4 text-[#051641] transition-transform duration-300" />
                        ) : (
                          <IoChevronDownOutline className="w-4 h-4 ml-1 text-black transition-transform duration-300" />
                        )}
                      </Popover.Button>

                      <Transition
                        as={Fragment}
                        show={openMore}
                        enter="transition ease-out duration-200"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <Popover.Panel className="absolute top-full -ml-6 text-sm shadow rounded overflow-hidden w-full max-w-[130px] bg-white z-20">
                          {navigation.morepages.map((item, index) => (
                            <Link to={item.to} key={index}>
                              <p className="relative p-3 bg-white hover:bg-gray-100 hover:text-red-600">
                                {item.name}
                              </p>
                            </Link>
                          ))}
                        </Popover.Panel>
                      </Transition>
                    </Popover>
                  </div>
                </div>
              </Popover.Group>
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
};

export default Header;
